export const extractErrorMessage = (errorMessage?: string): string | undefined => {
  if (!errorMessage) return undefined;
  const parts = errorMessage.split(': ');
  return parts.length > 1 ? parts[1] : errorMessage;
};
